import './CompanyCard.scss';

const CompanyCard = ({ company }) => {
    if (!company?.value) return null;

    return (
        <div className="company-card">
            <div className="company-card__header">
                <div className="company-card__title-group">
                    <div className="company-card__title">
                        {company?.label || 'Название компании'}
                    </div>
                    {company.alies && (
                        <div className="company-card__alias">
                            {company?.alies}
                        </div>
                    )}
                </div>
            </div>

            <div className="company-card__grid">
                {/* Форма юр.лица */}
                <div className="company-card__item">
                    <div className="company-card__item-label">Форма</div>
                    <div className="company-card__item-value">
                        {company?.form_legal_entity || '-'}
                    </div>
                </div>

                {/* ИНН */}
                <div className="company-card__item">
                    <div className="company-card__item-label">ИНН</div>
                    <div className="company-card__item-value">
                        {company?.inn || '-'}
                    </div>
                </div>

                {/* КПП */}
                <div className="company-card__item">
                    <div className="company-card__item-label">КПП</div>
                    <div className="company-card__item-value">
                        {company?.kpp || '-'}
                    </div>
                </div>

                {/* Телефон */}
                <div className="company-card__item company-card__item--full">
                    <div className="company-card__item-label">Телефон</div>
                    <div className="company-card__item-value">
                        {company?.phone || '-'}
                    </div>
                </div>

                {/* Email */}
                <div className="company-card__item company-card__item--full">
                    <div className="company-card__item-label">Email</div>
                    <div className="company-card__item-value company-card__item-value--break">
                        {company?.email || '-'}
                    </div>
                </div>

                {/* Адрес */}
                <div className="company-card__item company-card__item--full">
                    <div className="company-card__item-label">Адрес</div>
                    <div className="company-card__item-value company-card__item-value--break">
                        {company?.address || '-'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanyCard;